import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { AutoComplete } from '.';
import { intersectionWith,uniq } from 'lodash';
import { USER_PROFILE_ROLE, USER_ACTIVITY, REFERRAL_SOURCE, MODEL_TAGS, RECEIVE_RaM_Notifications } from '../constants';

const UserPeferences = ({}) => {
  const { register, getValues, setValue } = useFormContext(); // retrieve all hook methods
  const [selectedRole, setSelectedRole] = useState('');
  const [receiveRaMNotifications, setReceiveRaMNotifications] = useState('');
  const [referralSource, setReferralSource] = useState('');
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedinterestApplications, setInterestApplications] = useState([]);

  useEffect(() => {
    const userInfo = getValues();
    // console.log('userInfo', userInfo);
    if (userInfo && userInfo.preferences) {
      const role = USER_PROFILE_ROLE.find((item) => item.name === userInfo.preferences.userRole);
      setSelectedRole(role);
      if (userInfo?.preferences?.referralSource) {
        const referralSource = REFERRAL_SOURCE.find((item) => item.name === userInfo.preferences.referralSource);
        setReferralSource(referralSource);
      }
      const receiveRaMNotifications = RECEIVE_RaM_Notifications.find(
        (item) => item.name === userInfo.preferences?.receiveRaMNotifications
      );
      setReceiveRaMNotifications(receiveRaMNotifications);
      // setThumbnailUrl(userInfo?.base64ProfilePhoto);
      if (userInfo?.preferences?.activities) {
        const activities = intersectionWith(
          USER_ACTIVITY,
          userInfo?.preferences?.activities,
          (o, activity) => o.name === activity
        );
        setValue('userInfo?.preferences?.activities', uniq(activities))
        setSelectedActivities(uniq(activities));
      }
      if (userInfo?.preferences?.interestApplications) {
        const applications = intersectionWith(
          MODEL_TAGS,
          userInfo?.preferences?.interestApplications,
          (o, application) => o.key === application
        );
        setInterestApplications(applications);
      }
    }
  }, [getValues('preferences')]);
  const handlePrefrenceChange = (selectedValue: any, fieldName) => {
    const userPreference = getValues('preferences');
    // userPreference[fieldName] = selectedValue;
    // console.log('handlePrefrenceChange', { selectedValue, fieldName });
    switch (fieldName) {
      case 'userRole':
        userPreference[fieldName] = selectedValue.name;
        setSelectedRole(selectedValue);
        break;
      case 'activities':
        const activities = selectedValue.map((a) => a.name);
        // console.log('activities', activities);
        userPreference[fieldName] = activities;
        setSelectedActivities(selectedValue);
        break;
      case 'receiveRaMNotifications':
        userPreference[fieldName] = selectedValue.name;
        break;
      case 'referralSource':
        userPreference[fieldName] = selectedValue.name;
        break;
      case 'interestApplications':
        const applications = selectedValue.map((a) => a.key);
        // console.log('applications', applications);
        userPreference[fieldName] = applications;
        setInterestApplications(selectedValue);
        break;
      default:
        break;
    }
    setValue('preferences', userPreference);
  };

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '3px', marginLeft: '0px' }}>
        <Grid item xs={12} md={6}>
          <AutoComplete
            id="select-role"
            items={USER_PROFILE_ROLE}
            itemText="label"
            itemKey="name"
            labelText="How would you describe yourself?"
            defaultValue={selectedRole ?? ''}
            placeHolderText="Select option"
            multiSelect={false}
            onChange={(v) => handlePrefrenceChange(v, 'userRole')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AutoComplete
            id="select-activity"
            items={USER_ACTIVITY}
            itemText="label"
            itemKey="name"
            labelText="How do you plan on using ModelCentral?"
            defaultValue={selectedActivities ?? []}
            placeHolderText="Select option"
            multiSelect={true}
            onChange={(v) => handlePrefrenceChange(v, 'activities')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AutoComplete
            id="select-REFERRAL-SOURCE"
            items={REFERRAL_SOURCE}
            itemText="label"
            itemKey="name"
            labelText="How did you hear about us?"
            defaultValue={referralSource ?? ''}
            placeHolderText="Select option"
            multiSelect={false}
            onChange={(v) => handlePrefrenceChange(v, 'referralSource')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AutoComplete
            id="select-interestApplications"
            items={MODEL_TAGS}
            itemText="displayName"
            itemKey="key"
            labelText="What areas are you most interested in?"
            defaultValue={selectedinterestApplications ?? []}
            placeHolderText="Select option"
            multiSelect={true}
            onChange={(v) => handlePrefrenceChange(v, 'interestApplications')}
            limitTags={5}
          />
        </Grid>
        <Grid item xs={12}>
          <AutoComplete
            id="select-activity"
            items={RECEIVE_RaM_Notifications}
            itemText="label"
            itemKey="name"
            labelText="Do you want to be notified by email when someone posts a new RaM (Request-a-Model) request?"
            defaultValue={receiveRaMNotifications ?? ''}
            placeHolderText="Select option"
            multiSelect={false}
            onChange={(v) => handlePrefrenceChange(v, 'receiveRaMNotifications')}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default UserPeferences;
